import React, { Component } from 'react';
import { connect } from 'react-redux';

import { closeModal } from '../modules/active_modal';
import { placeOrder } from '../modules/order_actions';

import ModalCartItem          from './ModalCartItem.jsx';
import CustomerAddress        from './CustomerAddress.jsx';
import PromoDropin            from './PromoDropin.jsx';
import CustomBraintreeDropin  from './CustomBraintreeDropin.jsx';

class ModalCart extends Component {

  constructor(props) { // getInitialState
    super(props);
  }

  render() {
    let oCartErrorMessaging         = this.props.cartError ? (
      <div className='errorMessage showing'>
        <p>{this.props.cartError}</p>
      </div>
      ) : '';
    let oCreditDashboard = <div />;
    let bButtonDisabled = true;
    let {dispatch} = this.props;
    let oCart = <h6 className="center">Your box is empty.</h6>;
    let oBraintreeDropin = '';
    let oCartProducts = this.props.computedCart.items.map((oItem, i) => {
      return (
        <ModalCartItem
          key               = {'ModalCartItem' + (oItem && oItem.mmid ? oItem.mmid + '-' + i : i)}
          arrayItem         = {i}
          showCredit        = {this.props.storeType === "Neglite"} />
      );
    }, this);

    // Ensure we have a cart to loop through.

    if( parseInt(this.props.computedCart.items.length) > 0 ) {
      bButtonDisabled = false;
      oCart = (
          <div>
            <table className="cart-order-items">
              <thead>
                <tr className="cart-header">
                  <th className="col-first"></th>
                  <th className="col-second">Title</th>
                  <th className="col-third">Price</th>
                  <th className="col-fourth">Qty.</th>
                  { this.props.storeType === "Neglite" && this.props.credit_total && this.props.credit_total > 0 ? <th className="col-fourth2">Credits</th> : '' }
                  <th className="col-fifth">Total</th>
                </tr>
              </thead>
              <tbody>
                {oCartProducts}
              </tbody>
            </table>
            <div className="cart-order-summary">
              <div className="section" id="cart-totals">
                <div className="clearfix">
                  <div className="float-left">Subtotal</div>
                  <div className="float-right">${(parseFloat(this.props.computedCart.subtotal)).toFixed(2)}</div>
                </div>
                <div className="clearfix">
                  <div className="float-left">Shipping</div>
                  <div className="float-right">{(this.props.computedCart.shipping === 0 )? 'FREE' : '$' + this.props.computedCart.shipping }</div>
                </div>
                <div className="clearfix">
                  <div className="float-left">Estimated Tax</div>
                  <div className="float-right">${(parseFloat(this.props.computedCart.tax)).toFixed(2)}</div>
                </div>
                <div className="clearfix total">
                  <div className="float-left"><strong>Total</strong></div>
                  <div className="float-right"><strong>${(parseFloat(this.props.computedCart.total)).toFixed(2)}</strong></div>
                </div>
              </div>
            </div>
          </div>
      );
      oBraintreeDropin = (
        <CustomBraintreeDropin
          submitFunction = {placeOrder}
          uniqueContainer = "cart-form" />
        );
    }

    if( this.props.storeType === "Neglite" )
      oCreditDashboard = (
        <div className="creditsDashboard">
          <h4 className="alt">Your Member Credits</h4>
          <div className="half-col center left">
            <h2 className="highlight-color">{this.props.computedCart.credits_used}</h2>
            <span>Used</span>
          </div>
          <div className="half-col center">
            <h2 className="highlight-color">{this.props.computedCart.credits_available}</h2>
            <span>Available</span>
          </div>
        </div>
      );

    return (
        <div className="member-cart">
          <div className="modal-header content-max-width">
            <div className="button-wrapper">
              <button className="btn-secondary" onClick={() => dispatch( closeModal() )}>Continue shopping</button>
            </div>
            <div className="cart-header"><h2>Your Order</h2></div>
          </div>
          <div className="modal-body content-max-width">
            {oCartErrorMessaging}
            <div className="col-70">
              {oCart}
            </div>
            <div className="col-30 cart-account-info">
              {oCreditDashboard}
              <h4 className="alt">Your Information</h4>
              <CustomerAddress />
              <PromoDropin />
              <div className="section">
                <h4 className="alt">Payment Information</h4>
                {oBraintreeDropin}
              </div>
            </div>
          </div>
        </div>
    );
  }
};


function mapStateToProps(state){
    return {
      'computedCart': state.computedCart,
      'cartError': state.cartError,
      'storeType': state.store.type,
      'promos': state.promos,
      'credit_total': state.customer.credit_total,
      'notifications' : state.customer.notifications
    };
}

export default connect(mapStateToProps)(ModalCart);



// WEBPACK FOOTER //
// ./src/components/ModalCart.jsx